import React from 'react';
import Icon from './Icon';


function IconSort(props) {
  return (<>
    <Icon width="8" height="11" style={props?.style} className={props?.className}>
      <path d="M4 0.5L7.4641 5H0.535898L4 0.5Z" />
      <path d="M4 10.5L7.4641 6H0.535898L4 10.5Z" />
    </Icon>
  </>);
};

export default IconSort;
